import CustomIcon from 'components/common/CustomIcon';
import {useTranslation} from 'react-i18next';
import {Message, Wrapper} from './styled';

export enum NavigationStatus {
  success = 'success',
  warning = 'warning',
}
export type NavigationAlertProps = {
  status: NavigationStatus;
};

const defaultProps: NavigationAlertProps = {
  status: NavigationStatus.warning,
};

function NavigationAlert({status}: NavigationAlertProps) {
  const {t} = useTranslation();

  const messages = {
    [NavigationStatus.success]: 'online_chekin_successfully_completed',
    [NavigationStatus.warning]: 'please_complete_required_actions_before_arrival',
  };

  const icon =
    status === NavigationStatus.success ? 'checkSecondary' : 'warningSecondary';

  return (
    <Wrapper status={status}>
      <CustomIcon size={18} name={icon} />
      <Message>{t(messages[status])}</Message>
    </Wrapper>
  );
}

NavigationAlert.defaultProps = defaultProps;

export {NavigationAlert};
